import { rqClient } from "@/shared/api/instance";
import { Badge } from "@/shared/ui/kit/badge";

type NotificationBadgeProps = {
  className?: string;
  showCount?: boolean;
};

export function NotificationBadge({
  className,
  showCount = false,
}: NotificationBadgeProps) {
  const { data } = rqClient.useQuery(
    "get",
    "/api/v1/notifications/unread_count",
  );
  const unreadCount = data?.count ?? 0;

  if (unreadCount === 0) return null;

  if (showCount) {
    return (
      <Badge className={className} data-testid="notifications-unread-badge">
        {unreadCount > 99 ? "99+" : unreadCount}
      </Badge>
    );
  }

  return (
    <span
      className={className}
      data-testid="notifications-unread-badge"
      aria-hidden
    />
  );
}
